var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7459",
    "data-name": "Group 7459",
    transform: "translate(-1544 -143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1544 143)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7242",
    "data-name": "Path 7242",
    d: "M21.095,61H2.539A2.542,2.542,0,0,0,0,63.539V76.463A2.542,2.542,0,0,0,2.539,79H21.095a2.542,2.542,0,0,0,2.539-2.539V63.539A2.542,2.542,0,0,0,21.095,61Zm1.154,2.539V76.463a1.119,1.119,0,0,1-.012.168L15.579,70l6.657-6.63A1.119,1.119,0,0,1,22.249,63.539Zm-1.154-1.154a1.2,1.2,0,0,1,.159.011l-9.437,9.4L2.38,62.4a1.2,1.2,0,0,1,.159-.011ZM1.4,76.631a1.119,1.119,0,0,1-.012-.168V63.539a1.119,1.119,0,0,1,.012-.168L8.054,70Zm1.142.986a1.2,1.2,0,0,1-.159-.011l6.656-6.628,2.293,2.283a.692.692,0,0,0,.977,0L14.6,70.978l6.656,6.628a1.2,1.2,0,0,1-.159.011Z",
    transform: "translate(1547.183 88.013)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.8758e1cdcbe648d3b049efc5b475f361.svg";
export { ForwardRef as ReactComponent };